import React, { FC } from 'react'

import { DecorationTitle, Txt, Tooltip } from 'src/components/atoms'
import { CodeSnippet } from 'src/components/organisms/codeSnippets/CodeSnippet'

import { SamlIdpEntity } from 'src/types'

type Props = {
  samlIdp: SamlIdpEntity
  className?: string
}

export const ServiceProviderSetting: FC<Props> = ({ samlIdp, className }) => {
  return (
    <div className={className}>
      <Tooltip
        placement="top"
        content={
          <Txt sizeType="s">
            ユーザーの認証結果や属性情報を受け
            <br />
            取るためのサービスプロバイダのURL
          </Txt>
        }
      >
        <DecorationTitle>サービスプロバイダー情報</DecorationTitle>
      </Tooltip>
      <div className="tw-mt-s2">
        <Txt className="tw-font-bold">応答URL（Assertion Consumer Service URL）</Txt>
        <CodeSnippet title="URL" text={samlIdp.assertionConsumerServiceURL} className="tw-mt-s2" />
      </div>
      <div className="tw-mt-s4">
        <Tooltip
          placement="top"
          content={<Txt sizeType="s">サービスプロバイダから提供される、グローバルに一意の名前</Txt>}
        >
          <Txt className="tw-font-bold">エンティティID</Txt>
        </Tooltip>
        <CodeSnippet title="URL" text={samlIdp.serviceProviderURN} className="tw-mt-s2" />
      </div>
    </div>
  )
}
